import { SERVICE_LANES } from "@/config/resources";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_c36fe051-3d1f-49c1-a3e2-d610d9af7ab4/artifacts/fhd5bl7q_MovingMyMama-Logo-Web.png";

export const laneLabel = (v) => SERVICE_LANES.find((l) => l.value === v)?.label || prettify(v);

export function prettify(v) {
  if (v === null || v === undefined || v === "") return "";
  return String(v)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatDate(v) {
  if (!v) return "";
  try {
    const d = new Date(v);
    if (isNaN(d)) return v;
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return v;
  }
}

export function formatDateTime(v) {
  if (!v) return "";
  try {
    const d = new Date(v);
    if (isNaN(d)) return v;
    return d.toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return v;
  }
}

export function formatCurrency(v) {
  const n = Number(v || 0);
  return n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
}

// Status keyword -> color
const GREEN = { bg: "rgba(47,125,90,0.12)", color: "#256B4B", border: "rgba(47,125,90,0.28)" };
const NAVY = { bg: "rgba(28,67,88,0.10)", color: "#1C4358", border: "rgba(28,67,88,0.20)" };
const SKY = { bg: "rgba(155,185,206,0.25)", color: "#1C4358", border: "rgba(155,185,206,0.45)" };
const KHAKI = { bg: "rgba(196,200,155,0.35)", color: "#5A5E2E", border: "rgba(196,200,155,0.60)" };
const AMBER = { bg: "rgba(183,121,31,0.14)", color: "#9A6516", border: "rgba(183,121,31,0.30)" };
const RED = { bg: "rgba(156,30,34,0.10)", color: "#9C1E22", border: "rgba(156,30,34,0.24)" };
const GRAY = { bg: "rgba(75,85,99,0.10)", color: "#4B5563", border: "rgba(75,85,99,0.22)" };

const MAP = {
  // green / success
  done: GREEN, completed: GREEN, closed: GREEN, sold: GREEN, placed: GREEN, active: GREEN,
  won: GREEN, paid: GREEN, converted: GREEN, engaged: GREEN, invoiced: GREEN,
  // sky / in-progress
  in_progress: SKY, contacted: SKY, touring: SKY, scheduled: SKY, listed: SKY, prep: SKY,
  qualified: SKY, consultation_booked: SKY, applied: SKY,
  // khaki / new
  new: KHAKI, todo: KHAKI, assessment: KHAKI, planning: KHAKI, researching: KHAKI,
  prospect: KHAKI, potential: KHAKI, pending: KHAKI, light_support: KHAKI,
  // amber / warning
  on_hold: AMBER, no_show: AMBER, quoted: AMBER, under_contract: AMBER, high: RED, medium: AMBER, low: SKY,
  // red / negative
  lost: RED, cancelled: RED, declined: RED, inactive: GRAY, archived: GRAY,
  // care levels
  independent: SKY, assisted: AMBER, memory_care: RED, skilled: RED, assisted_living: AMBER,
  skilled_nursing: RED, in_home: GREEN,
  // email delivery statuses
  queued: KHAKI, sending: SKY, sent: SKY, delivered: GREEN, opened: GREEN, clicked: GREEN,
  retry: AMBER, delayed: AMBER, bounced: RED, complained: RED, failed: RED,
  skipped: GRAY, suppressed: GRAY, unsubscribed: GRAY,
};

export function statusStyle(value) {
  if (!value) return GRAY;
  return MAP[String(value).toLowerCase()] || NAVY;
}
